import { render, staticRenderFns } from "./Identity.vue?vue&type=template&id=158256a5&scoped=true"
import script from "./Identity.vue?vue&type=script&lang=js"
export * from "./Identity.vue?vue&type=script&lang=js"
import style0 from "./Identity.vue?vue&type=style&index=0&id=158256a5&prod&lang=css"
import style1 from "./Identity.vue?vue&type=style&index=1&id=158256a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158256a5",
  null
  
)

export default component.exports